import { withInstall } from '@vitamin/shared'
import ActionSheet from './src/action-sheet.vue'

export const VcActionSheet = withInstall(ActionSheet)
export default VcActionSheet
